var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrain = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "-1 -1 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.695 18.79 1.99 1.657V21H2.21v-.553L4.2 18.79H2.21A2.21 2.21 0 0 1 0 16.579V4.42A4.421 4.421 0 0 1 4.421 0h11.053a4.421 4.421 0 0 1 4.42 4.421V16.58a2.21 2.21 0 0 1-2.21 2.21h-1.99ZM2.21 4.42v4.421h15.473V4.421H2.211ZM9.947 16.58a2.21 2.21 0 1 0 0-4.42 2.21 2.21 0 0 0 0 4.42Z",
  fill: "#fff"
})));
export { SvgTrain as ReactComponent };
export default __webpack_public_path__ + "static/media/4acca598.svg";